import apiClient from '../lib/axios';

export interface EmailConfig {
  id: string;
  provider: string;
  smtpHost: string;
  smtpPort: number;
  smtpSecure: boolean;
  smtpUser: string;
  smtpPassword: string; // Always masked by the server ('********')
  fromEmail: string;
  fromName: string;
  isActive: boolean;
  isDefault: boolean;
  testEmailSent: boolean;
  lastTestedAt: string | null;
  updatedAt: string;
}

export interface SaveEmailConfigPayload {
  provider?: string;
  smtpHost: string;
  smtpPort: number;
  smtpSecure: boolean;
  smtpUser: string;
  // Leave undefined/blank to keep the current password.
  smtpPassword?: string;
  fromEmail: string;
  fromName: string;
}

class EmailService {
  async getConfig(): Promise<EmailConfig | null> {
    const response = await apiClient.get('/admin/email');
    return response.data.data;
  }

  async saveConfig(payload: SaveEmailConfigPayload): Promise<EmailConfig> {
    const response = await apiClient.put('/admin/email', payload);
    return response.data.data;
  }

  async sendTest(testEmailTo: string): Promise<{ message: string }> {
    const response = await apiClient.post('/admin/email/test', { testEmailTo });
    return response.data.data;
  }
}

export const emailService = new EmailService();
